import { render, staticRenderFns } from "./loginplain.vue?vue&type=template&id=f4d99788&scoped=true&lang=html"
import script from "./loginplain.vue?vue&type=script&lang=js"
export * from "./loginplain.vue?vue&type=script&lang=js"
import style0 from "./loginplain.vue?vue&type=style&index=0&id=f4d99788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d99788",
  null
  
)

export default component.exports